import { render, staticRenderFns } from "./aiWatchingScreen.vue?vue&type=template&id=04eb7fd8&scoped=true"
import script from "./aiWatchingScreen.vue?vue&type=script&lang=ts"
export * from "./aiWatchingScreen.vue?vue&type=script&lang=ts"
import style0 from "./aiWatchingScreen.vue?vue&type=style&index=0&id=04eb7fd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04eb7fd8",
  null
  
)

export default component.exports